import { UseQueryOptions } from '@tanstack/react-query'
import { IPaginationParams, QueryKey, SortDirection, usePaginatedApi } from 'modules/module-api'
import security from 'modules/module-security'
import { ICourierDto } from 'modules/module-settings/api/dto'
import { useAppSelector } from 'modules/module-utils'
import { useDebounce } from '../../../module-utils/hooks/use-debounce/use-debounce'

export enum CouriersSortField {
  NAME = 'NAME',
  TYPE = 'TYPE',
}

export interface IUseCouriersParams extends IPaginationParams<CouriersSortField> {}

export const useCouriers = (
  params: IUseCouriersParams = {
    page: 1,
    pageSize: 10,
    sortBy: CouriersSortField.NAME,
    sort: SortDirection.ASC,
    filter: '',
  },
  queryOptions?: UseQueryOptions<any>,
) => {
  const clientId = useAppSelector(security.selectors.clientId)
  const debouncedFilter = useDebounce('')(params.filter)

  const { data, ...rest } = usePaginatedApi(
    QueryKey.COURIERS,
    ICourierDto,
    '/v3/couriers',
    {
      ...params,
      client_id: clientId,
      filter: debouncedFilter,
    },
    queryOptions,
  )

  return {
    couriers: data,
    ...rest,
  }
}

export default useCouriers
